import { render, staticRenderFns } from "./CellRendererApprovalStatus.vue?vue&type=template&id=6ed58a10&scoped=true"
import script from "./CellRendererApprovalStatus.vue?vue&type=script&lang=js"
export * from "./CellRendererApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed58a10",
  null
  
)

export default component.exports